import styles from './Template.module.scss'
import ServicesFV from 'components/services/common/ServicesFV'
import Philosophy from 'components/services/common/Philosophy'
import Strength from 'components/services/common/Strength'
import MainMethods from 'components/services/common/MainMethods/MainMethods'
import ProcessUIUX from 'components/services/common/ProcessUIUX'
import ServiceDetail from 'components/services/common/ServiceDetail/ServiceDetail'
import MobileAppDevelopment from 'components/services/common/MobileAppDevelopment'
import RelatedPosts from 'components/services/common/RelatedPosts'
import type { RelatedPostsItem } from 'components/services/common/RelatedPosts/RelatedPosts'
import FooterCTA from 'components/common/FooterCTA'

const paths = [
  { name: 'TOP', url: '/' },
  { name: 'Services', url: '#' },
  { name: 'UX/UI改善', url: '#' },
]

const ServicesFVList = {
  category: 'デジタルプロダクトデザイン',
  title: (
    <>
      <span>U</span>
      <span>X</span>
      <span>/</span>
      <span>U</span>
      <span>I</span>
      <span>改</span>
      <span>善</span>
    </>
  ),
  text: (
    <>
      モバイルアプリ、SaaSプロダクト、業務アプリケーションやECサイトなど幅広いプロダクトのUIを設計いたします。OOUI（オブジェクト指向UI）を取り入れた設計でユーザビリティを徹底的に追求。さらに、効率的で一貫性のある開発をサポートするデザインシステムの構築も可能です。
    </>
  ),
  imgSrc: '/img/services/services_fv_uxui.webp',
  alt: 'UX/UI改善',
}

const philosophy = [
  {
    title: '高速に基礎を築き、付加価値を加える',
    text: 'UIデザインは美しい外見や素敵なコンセプトだけでは成り立ちません。はじめに土台となるユーザビリティを固めなければ、外見やコンセプトも本来の価値を発揮しないのです。ユーザー体験をより豊かにすべく、私たちは使いやすさを徹底的に追求します。',
  },
  {
    title: 'ビジネスへのインパクトとUIデザインの役割',
    text: 'プロダクトにおいて、ユーザーがサービスの価値を実感するプロセスをスムーズに設計することは非常に重要です。私たちは、OOUI（オブジェクト指向UI）などのコンテンツ中心の設計手法を活用し、サービスのコンセプトを直感的に理解できるプロダクトを提供します。',
  },
  {
    title: '車輪の再発明を減らす',
    text: 'ディスプレイ（タッチ）デバイスのアプリケーションにおけるビジュアルトレンドは既に成熟し、主要なUIパーツはベストプラクティスによって標準化されているためプロジェクトごとにゼロから作り直す必要はありません。これにより、骨格の構築は迅速に進められ、より多くの時間を構造設計やユーザビリティの検証、ビジュアルのブラッシュアップなどに費やすことが可能です。',
  },
]

const strengthList = [
  {
    title: 'ロジカルで納得感のある設計',
    text: (
      <>
        OOUIやブランドアーキタイプといったフレームワークを取り入れ、ロジカルな設計を行います。
        <br />
        ブラックボックス化しがちなワイヤーやビジュアル策定のプロセスを透明化し、思考を共有しながら制作を進めることで、納得感のあるデザインを提供します。
      </>
    ),
  },
  {
    title: 'デザインシステムのナレッジ',
    text: (
      <>
        デザイントークン管理による一貫性のあるデザインによってブランドやUIの統一感を維持します。
        <br />
        効率的で再利用が可能なコンポーネント設計により、プロダクトのスケーラビリティを向上させ、デザインと開発の連携を強化します。
      </>
    ),
  },
  {
    title: '高速な検証と改善',
    text: (
      <>
        デザインシステムの活用により、車輪の再発明を防いで画面構築コストを削減します。
        <br />
        同時に、ユーザビリティチェックリストや自社ガイドラインを用いて、基礎的なセオリーを満たしたデザインを早期に制作。発展的なブラッシュアップに集中することで高品質なデザインを提供します。
      </>
    ),
  },
]

const items = [
  {
    src: '/img/services/uxui_methods_ooui.webp',
    title: 'オブジェクトモデリング(OOUI)',
    description: (
      <>
        OOUIは、プロダクトで扱われるオブジェクト（対象物）を中心に情報設計を行う手法です。
        <br />
        OOUIに準拠したプロダクトでは、ユーザーは画面上でオブジェクトを選択し、それからそのオブジェクトへのアクションを選びます。これは現実世界での人間の意思決定と同じ順番のため、違和感のない操作を実現する重要な要素となります。
        <br />
        OOUIの思想を情報設計プロセスに組むことで、ユーザーとプロダクトとをスムーズに繋げることができます。
      </>
    ),
    inpocketTitle: 'オブジェクトベースのUI(OOUI)',
    inpocketUrl: 'https://aitria.co.jp/in-pocket/what-is-ooui/',
    noteTitle: '',
    noteUrl: '',
  },
  {
    src: '/img/services/uxui_methods_use.webp',
    title: 'ユースケース・シナリオ設計',
    description: (
      <>
        UI設計には、システムとユーザーの行動の整理が不可欠です。1つ1つの機能要件には意味や繋がりがあり、それらのあるべき姿・いるべき場所を精査する必要があります。画面上に機能をただ当てはめるだけでは、その繋がりが欠け、操作や構造に大きな違和感が発生しかねません。
        <br />
        整理した内容は、以降の工程であるオブジェクトモデリングやワイヤーに反映され、システム/ユーザー目線を持った情報設計に繋がります。
      </>
    ),
    inpocketTitle: '',
    inpocketUrl: '',
    noteTitle: '',
    noteUrl: '',
  },
  {
    src: '/img/services/uxui_methods_system.webp',
    title: 'デザインシステム・トークン設計',
    description: (
      <>
        デザイン制作のルールやガイドライン、パターンなど、プロダクトの一貫性を保つための一連のリソースを総合して「デザインシステム」と呼びます。活用することで組織内でのデザインプロセスの効率化や標準化が可能です。
        <br />
        コンセプト策定から開発への連携までの全プロセスを一気通貫で実施し、より高度で一貫性のあるデザインシステムを制作いたします。
        <br />
        また、お客様のチーム内でデザインシステムを維持・発展させられるよう、構築前後の内製化サポートも行っています。
      </>
    ),
    inpocketTitle: 'プロダクト開発の効率と一貫性を高める！デザインシステムの導入ステップと成功のポイント',
    inpocketUrl: 'https://aitria.co.jp/in-pocket/how-to-implement-design-system/',
    noteTitle: '',
    noteUrl: '',
  },
  {
    src: '/img/services/uxui_methods_expert.webp',
    title: 'エキスパートレビュー',
    description: (
      <>
        経験豊富なUIデザイナーがプロダクトを構造・骨格・表層の3つの視点から丁寧に分析し、課題を特定します。
        <br />
        ヤコブ・ニールセンが提唱した10のヒューリスティクス（UIの使いやすさの原則）も基準の1つとして活用し、経験と理論の両面から評価を行います。
        <br />
        特定された課題を元にプロダクト全体の改善方針を導き、具体的な修正案と合わせてご提案いたします。
      </>
    ),
    inpocketTitle: 'エキスパートレビューとは？意味や観点、ヒューリスティック分析・ユーザビリティテストとの違いを解説',
    inpocketUrl: 'https://aitria.co.jp/in-pocket/what-is-expert-review/',
    noteTitle: 'UIデザインのための10のヒューリスティクスについて改めて考えてみた',
    noteUrl: 'https://note.com/aitria_design/n/n5df01b921e04',
  },
  {
    src: '/img/services/uxui_methods_brand.webp',
    title: 'ブランドアーキタイプ分析',
    description: (
      <>
        心理学者のユングは「人々の深層に共通して存在し、夢などに現れる心理パターン」を「アーキタイプ」と呼びました。これを企業やブランドに当てはめ、ブランド人格を導く手法を「ブランドアーキタイプ」といいます。
        <br />
        ブランドの該当アーキタイプの分析や新たなアーキタイプの付与によって、市場競争力やユーザーとのつながりを強化できるとされています。
        <br />
        このブランドアーキタイプをプロダクト人格を導くために用いることで、検討をより論理的に進め、大幅なすれ違いを防ぐことができます。
      </>
    ),
    inpocketTitle: '',
    inpocketUrl: '',
    noteTitle: 'プロダクトの世界観を統一する！「ブランドアーキタイプ」をUIデザインに活用する方法',
    noteUrl: 'https://note.com/iaitria_design/n/na4038647867b',
  },
]

const ServiceDetailList = [
  {
    title: 'アプリケーションUIデザイン',
    subTitle1: 'Webサービス',
    text1:
      'SaaS・業務支援系システムを中心に、デザインの知見を活かした設計を行います。ECサイト制作の実績も多数ございます。',
    subTitle2: 'エキスパートレビュー',
    text2: 'プロダクトを構造・骨格・表層に分けて分析し、課題を特定します。',
    subTitle3: 'ネイティブアプリ',
    text3:
      'iOSやAndroidといったネイティブアプリ独自のルールについての豊富な知識・経験を元に、適切なデザインをご提供します。',
  },
  {
    title: 'デザインシステム構築',
    linkText: 'サービスページを見る',
    linkUrl: '/services/studio/design-system/',
    subTitle1: 'デザインシステム構築支援',
    text1:
      'デザインの一貫性を保つためのガイドラインやコンポーネントライブラリを作成し、組織内のデザイン標準やプロセスの改善に繋げます。',
    subTitle2: 'デザインシステムコンサルティング',
    text2: '我々の手を離れた後もデザインシステムがお客さまの元で発展し続けられるよう、内製化支援を行うことも可能です。',
    subTitle3: '',
    text3: '',
  },
  {
    title: 'プロトタイピング',
    linkText: 'サービス資料を見る',
    linkUrl: '/download/prototyping/',
    subTitle1: 'プロトタイプ各種',
    text1:
      'Figmaプロトタイプを用い、画面遷移やインタラクションを再現した実際の使用感に近いモックアップを制作いたします。',
    subTitle2: 'ユーザー検証',
    text2:
      'プロトタイプを用いたユーザビリティテストを実施します。テストユーザーからのフィードバックを集め、より使いやすいプロダクトへブラッシュアップしていきます。',
    subTitle3: '',
    text3: '',
  },
  {
    title: 'ブランディング・コミュニケーションデザイン',
    subTitle1: 'ブランドアーキタイプ分析',
    text1:
      'ブランディング手法の1つである「ブランドアーキタイプ」を用いて、ブランド人格を確立させます。12の人格にプロダクトを当てはめ、デザイン原則やビジュアル、ボイス&トーンづくりに役立てます。',
    subTitle2: 'サイトデザイン',
    text2: 'コーポレートサイトやマーケティングアセットなど、BtoB・BtoCのデザインを制作いたします。',
    subTitle3: 'VI・ロゴ制作',
    text3:
      '丁寧なヒアリング、ブランドアーキタイプを用いて、シンボルマーク・アプリアイコンを制作します。プロダクト全体を通したVI計画のご提案も可能です。',
  },
]

const relatedPostsList: RelatedPostsItem = {
  sectionTitle: 'UX/UI改善の関連記事',
  relatedPosts: [
    {
      title: 'レガシーUIのリニューアルガイド：レガシーなUIの問題点、脱却のポイントを解説',
      link: 'https://aitria.co.jp/in-pocket/legacy-ui-renewal/',
      thumbnail: 'https://aitria.co.jp/in-pocket/wp-content/uploads/2025/03/thumbnail-3.png',
      day: '2025年7月24日',
      category: 'UX/UIデザイン',
    },
    {
      title: '【セミナーレポート】金融機関のUX/UI改善を阻む2つの壁と対応策',
      link: 'https://aitria.co.jp/in-pocket/finance-uiux-seminar-report/',
      thumbnail: 'https://aitria.co.jp/in-pocket/wp-content/uploads/2025/09/financial-uiux-1.png',
      day: '2025年9月19日',
      category: 'UX/UIデザイン',
    },
    {
      title: 'UX/UIに強いおすすめ開発会社4選：OOUIとデザインシステムでより良いユーザー体験を実現',
      link: 'https://aitria.co.jp/in-pocket/uiux-software-vendors/',
      thumbnail: 'https://aitria.co.jp/in-pocket/wp-content/uploads/2024/12/uiux-software-vendor-3-1.png',
      day: '2025年10月14日',
      category: 'UX/UIデザイン',
    },
    {
      title: 'UXリサーチは、AIと“分業”する時代へ──効率と深さを両立する実践ノウハウ',
      link: 'https://aitria.co.jp/in-pocket/ux-research-using/',
      thumbnail: 'https://aitria.co.jp/in-pocket/wp-content/uploads/2025/05/ux-research.png',
      day: '2025年6月2日',
      category: 'UX/UIデザイン',
    },
  ],
}

const UXUIImprovement: React.FC = () => {
  return (
    <>
      <ServicesFV ServicesFVEach={ServicesFVList} paths={paths} />
      <Philosophy list={philosophy} />
      <div className={styles.backGround}>
        <Strength list={strengthList} />
      </div>
      <MainMethods items={items} />
      <div className={styles.line}>
        <ProcessUIUX />
      </div>
      <div className={styles.line}>
        <ServiceDetail list={ServiceDetailList} />
      </div>
      <MobileAppDevelopment />
      <div className={styles.backGroundGray}>
        <RelatedPosts RelatedPostsEach={[relatedPostsList]} />
      </div>
      <FooterCTA />
    </>
  )
}

export default UXUIImprovement
